/**
 * "Sign in with SSO" button for OIDC auth mode.
 */

import React from 'react';
import { oidcSignIn } from '../../contexts/auth/OIDCAuthContext';

const OIDCLoginButton: React.FC = () => (
  <div className="w-full max-w-sm space-y-6 text-center">
    <h2 className="text-2xl font-semibold text-ui-text-primary">
      Sign in
    </h2>
    <p className="text-sm text-ui-text-tertiary">
      Use your organisation&apos;s identity provider to sign in.
    </p>
    <button
      onClick={() => oidcSignIn()}
      className="w-full rounded-md bg-lime-500 hover:bg-lime-600 text-white font-medium py-2.5 text-sm transition-colors"
    >
      Sign in with SSO
    </button>
  </div>
);

export default OIDCLoginButton;
